/**
 * @vuepress
 * ---
 * title: file
 * ---
 */
import moment from 'moment'
import Transformer from '@/transformers/transformer'

/**
 * @class minuteTransformer
 * minute file transformer
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 */
class minuteTransformer extends Transformer {
  /**
   * Transform file to update
   *
   * @param file to update file
   *
   * @returns {Object} The transformed file
   */

  static update(file) {
    const formData = new FormData()
    formData.append('file', file.file)
    formData.append('file_id', file.fileId || file.id)
    formData.append('date_content', moment(file.date).format() || null)
    formData.append('visible_customer', !!file.visibleCustomer)
    if(file.amount) {
      formData.append('amount', file.amount || null)
    }
    return formData
  }

}

export default minuteTransformer


// WEBPACK FOOTER //
// ./src/transformers/Files/minute.js